<template>
  <v-card :loading="billingImportStatus === 1">
    <v-card-title>
      <span class="headline">Import danych</span>
      <v-spacer />
      <v-chip
        v-if="fileContentErrors.length > 0"
        outlined
        small
        label
        color="error"
        >{{ fileContentErrors[0] }}</v-chip
      >
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row dense>
          <v-col cols="12">
            <v-file-input
              clearable
              v-model="file"
              label="Wybierz plik CSV"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="gray" text @click="close">Anuluj</v-btn>
      <v-btn color="secondary darken-1" text @click="handleSubmit"
        >Importuj</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import required from "vuelidate/lib/validators/required";

export default {
  components: {},
  data: () => ({
    file: null,
    fileWithHeader: true,
    fileContent: null,
  }),
  validations: {
    fileContent: {
      required,
    },
  },
  watch: {
    file(val) {
      if (!val) {
        this.fileContent = null;
      } else {
        //this.createBase64File(val);
        //this.fileContent = val.name;
        this.handleFile(val);
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    billingImportStatus() {
      return this.$store.getters.getBillingImportStatus();
    },
    billingImportText() {
      return this.$store.getters.getBillingImportText;
    },

    fileContentErrors() {
      const errors = [];
      if (!this.$v.fileContent.$dirty) return errors;
      !this.$v.fileContent.required && errors.push("Plik jest wymagany");
      return errors;
    },
  },

  methods: {
    handleFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        //this.fileContent = reader.result
        this.fileContent = this.csvToArray(reader.result,';');
      };
      reader.onerror = (e) => {
        console.log(e);
      };
      reader.readAsText(file,'windows-1250');
    },
    csvToArray(str, delimiter = ",") {
      const headers = str.slice(0, str.indexOf("\r\n")).split(delimiter);
      const rows = str.trim().slice(str.indexOf("\r\n") + 1).split("\r\n");
      const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
          object[header] = values[index];
          return object;
        }, {});
        return el;
      });
      // return the array
      return arr;
    },
    close() {
      this.$v.$reset();
      this.$emit("close");
    },
    handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        this.$store.dispatch("importBilling", {
          file_content: this.fileContent,
        });
      }
    },
  },
};
</script>

